import { observer } from "mobx-react-lite";
import React from "react";
import { FormattedMessage as FormattedMessageOriginal } from "react-intl";

export const FormattedMessage = observer(function FormattedMessage(
  props: React.ComponentProps<typeof FormattedMessageOriginal>,
) {
  const gender = "other";

  return (
    <FormattedMessageOriginal {...props} values={{ ...props.values, gender }} />
  );
});
